import type { DirectoryCardInfo } from "@components/DirectoryCard/types";
import { callApi } from "./index";

export const getDirectoryCards = (): Promise<DirectoryCardInfo> => {
  return callApi("/api/EasyDirectoryAPI/get-directory-cards", { });
}

export const getDirectoryCardsWithIcon = (supplierId: number | undefined): Promise<DirectoryCardInfo> => {
  return callApi(`/api/EasyDirectoryAPI/get-directory-cards?isReview=true${!!supplierId ? `&supplierId=${supplierId}` : ''}`, { });
}
